import * as Sentry from '@sentry/browser';
import LogRocket from 'logrocket';

import { AppEnv } from '../config/appEnv';
import config from '../config/config';

export const initExternalLogger = (
  dsn: string,
  appReleaseVersion: string | undefined,
) => {
  const inBrowser = typeof window !== 'undefined';
  const url = new URL(inBrowser ? window.location.href : 'https://app.genially.com');
  const isDevOrStaging = [AppEnv.Development, AppEnv.Staging].includes(config.appEnv);
  const shouldInit = (config.isProduction || isDevOrStaging) && url.protocol !== 'file';

  if (shouldInit) {
    Sentry.init({
      release: appReleaseVersion || 'unknown',
      defaultIntegrations: false,
      integrations: [new Sentry.Integrations.HttpContext()],
      dsn,
    });

    try {
      LogRocket.getSessionURL(sessionUrl => {
        Sentry.configureScope(scope => {
          scope.setTag('hasLogrocketSessionUrl', 'yes');
          scope.setExtra('sessionUrl', sessionUrl);
        });
      });
    } catch (e) {
      console.error('Failed to connect Logrocket to Sentry');
    }
  }
};

export const logToExternalService = (message: string) => {
  if (!config.debug) {
    Sentry.captureMessage(message);
  } else {
    console.error(`[EXTERNAL_LOGGER_SERVICE] ${message}`);
  }
};

export const logExceptionToExternalService = (exception: unknown) => {
  if (!config.debug) {
    Sentry.captureException(exception);
  } else if (exception instanceof Error) {
    console.error(`[EXTERNAL_LOGGER_SERVICE] ${exception.message} ${exception.stack}`);
  } else {
    console.error(`[EXTERNAL_LOGGER_SERVICE] ${exception}`);
  }
};
